module.exports = __webpack_public_path__ + "static/img/pay-en.2200f0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/en/pay-en.png
// module id = UaZd
// module chunks = 0